import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles } from "../../utils/createResponsiveStyles";
import { theme } from "../../theme";
export const getModalStyleSheet = (width, backgroundColor) => {
    return ResponsiveStyleSheet.create({
        modal: createResponsiveStyles({
            base: {
                paddingVertical: theme.spacing.medium,
                paddingHorizontal: theme.spacing.small,
                width: "96%",
                alignItems: "center",
                backgroundColor,
                borderRadius: theme.spacing.xsmall,
            },
            small: {
                paddingVertical: theme.spacing.xlarge2,
                paddingHorizontal: theme.spacing.xlarge2,
                width,
            },
        }),
    });
};
export const { styles, ids } = ResponsiveStyleSheet.create({
    webContainer: {
        zIndex: theme.stack.modal,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    },
    overlay: {
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: `${theme.colors.dark.base}AA`,
    },
    close: createResponsiveStyles({
        base: {
            position: "absolute",
            top: 0,
            right: 0,
            margin: theme.spacing.medium,
        },
        small: {
            margin: theme.spacing.large,
        },
    }),
    heading: {
        marginBottom: theme.spacing.medium,
    },
    actions: createResponsiveStyles({
        base: {
            flexDirection: "column",
            padding: theme.spacing.xsmall2,
            marginTop: theme.spacing.xsmall,
        },
        small: {
            flexDirection: "row",
        },
    }),
    action: {
        margin: theme.spacing.xsmall2,
    },
    children: {
        paddingTop: theme.spacing.xsmall,
        paddingBottom: theme.spacing.xsmall,
        textAlign: "center",
    },
    light: {
        backgroundColor: theme.colors.light.base,
        color: theme.colors.dark.base,
    },
    brand: {
        backgroundColor: theme.colors.brand.base,
        color: theme.colors.light.base,
    },
    accent: {
        backgroundColor: theme.colors.accent.base,
        color: theme.colors.dark.base,
    },
    warning: {
        backgroundColor: theme.colors.warning.base,
        color: theme.colors.dark.base,
    },
    greyscale: {
        backgroundColor: theme.colors.greyscale.base,
        color: theme.colors.light.base,
    },
});
//# sourceMappingURL=Modal.styles.js.map